<script>
import { createEventDispatcher } from 'svelte';
export let type = undefined; // can be 'submit'|'button'|'reset' for native type or a variant name
export let variant = 'primary';

const dispatch = createEventDispatcher();
const nativeTypes = new Set(['button', 'submit', 'reset']);
let nativeType = 'button';
let appliedVariant = variant;

if (type !== undefined) {
    if (nativeTypes.has(type)) {
        nativeType = type;
    } else {
        appliedVariant = type;
    }
}

function handleClick(e) {
    // re-dispatch click so consumers can listen on the component
    dispatch('click', e);
}
</script>

<button type={nativeType} class={appliedVariant} on:click={handleClick}>
    <slot></slot>
</button>

<style>
button {
    border: 0;
    cursor: pointer;
    border-radius: 6px;
    padding: 8px 12px;
    font-weight: bold;
    box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.2);
    transition: background-color 120ms ease, color 120ms ease, transform 80ms ease;
}
.primary {
    --bg: #d91b42;
    background-color: var(--bg);
    color: white;
}
.secondary {
    --bg: #45c496;
    background-color: var(--bg);
    color: white;
}

/* When pressed/focused swap colors: text becomes the previous background color */
.primary:active,
.primary:focus-visible,
.secondary:active,
.secondary:focus-visible {
    background-color: white;
    color: var(--bg);
    transform: translateY(1px);
}

/* Optional persisted 'pressed' class (if you toggle it from JS) */
.pressed {
    background-color: white !important;
    color: var(--bg) !important;
}
</style>